import Vue from 'vue';
import Vuex from 'vuex';
import baseUrl from "../utils/api";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    apiUrl: baseUrl,
    appId: 14,
    mainUser: {},

    editClassData: [], // Goods/editClass
    editClassBack: {},
  },
  mutations: {
    initMainUser(state, user) { // 初始化主体账号信息
      state.mainUser = user
    },
    getEditClassData(state, data) {
      state.editClassData = data
    },
    getEditClassBack(state, data) {
      state.editClassBack = data
    }
  },
  actions: {},
});



// WEBPACK FOOTER //
// ./src/store/index.js